import api from '../../utils/services/api';

import {
  userActionError,
  userActionLoading,
  userActionSuccess,
  userBalanceActionError,
  userBalanceActionLoading,
  userBalanceActionSuccess,
} from '../ducks/user';

export const userFetchAction = (id) => {
  return async (dispatch) => {
    dispatch(userActionLoading());
    try {
      const response = await api.get(`usuario/listar?CPFCNPJ_CLIENTE=${id}`);
      dispatch(userActionSuccess(response.data));
    } catch (error) {
      dispatch(userActionError(error?.response?.data));
    }
  };
};

export const userBalanceFetchAction = (id, filter) => {
  const params = {
    CPFCNPJ_CLIENT: id,
    LIMIT: filter.limit,
    DATAINICIAL: filter.DATAINICIAL,
    DATAFINAL: filter.DATAFINAL,
  };
  return async (dispatch) => {
    dispatch(userBalanceActionLoading());
    try {
      const response = await api.post(`usuario/historico/saldo`, params);
      dispatch(userBalanceActionSuccess(response.data));
    } catch (error) {
      dispatch(userBalanceActionError(error?.response?.data));
    }
  };
};
